// 参照/自定义档案数据权限
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import Ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils";
import platform from "Pub/js/platform";
const { NCCheckbox, NCSelect } = platform.base;
const { NCOption } = NCSelect;
function DataPermissionArea(props) {
    const { selectCard, dataSource, json, referData } = props;
    const [usedSceneData, setUsedSceneData] = useState([]);
    const currentRefPk = useRef();

    useEffect(() => {
        //切换参照时
        if(referData.pk) {
            getUsedSceneData();
            if(currentRefPk.current && currentRefPk.current !== referData.pk) {
                handleCheckboxChange(""); //清空复选框
            }
            currentRefPk.current = referData.pk;
        }
    }, [referData.pk]);

    //2207新增：请求使用场景下拉数据
    const getUsedSceneData = () => {
        const { pk, ...reqData } = referData;
        Ajax({
            url: "/nccloud/platform/templet/queryDataPowerUsageScenarios.do",
            data: reqData,
            info: {
                name: langCheck("ZoneSetting-000356", "pages", json) /* 国际化处理： 使用场景*/,
                action: langCheck("ZoneSetting-000200", "pages", json) /* 国际化处理： 查询*/,
            },
            success: res => {
                let { success, data } = res.data;
                const { resMapList = [] } = data;
                if (success) {
                    setUsedSceneData(resMapList);
                }
            },
        });
    };

    const handleSelectChange = val => {
        props.onUsedSceneChange(val);
    };

    const handleCheckboxChange = val => {
        props.onDataPowerEnableChange(val);
        if (val) {
            getUsedSceneData();
        } else {
            //取消数据权限清空使用场景
            handleSelectChange("");
        }
    };

    //渲染数据权限
    const renderDataPowerEnable = () => {
        return (
            <div className="mdcontentItem">
                <span className="refer_label">
                    {/* 启用数据权限 */}
                    {langCheck("ZoneSetting-000355", "pages", json)}
                </span>
                <NCCheckbox
                    checked={Boolean(dataSource.isdatapowerenable)}
                    onChange={handleCheckboxChange}
                />
            </div>
        );
    };

    //渲染使用场景
    const renderUsedScene = () => {
        //勾选数据权限显示使用场景
        if (!dataSource.isdatapowerenable) {return null;}
        return (
            <div className="mdcontentItem">
                <span className="refer_label">
                    {langCheck("ZoneSetting-000356", "pages", json)}
                </span>
                <span style={{ display: "inline-block" }}>
                    <NCSelect
                        style={{ width: 220 }}
                        showClear={false}
                        value={dataSource.datapoweroperationcode}
                        notFoundContent={langCheck("ZoneSetting-000278", "pages", json)}
                        onChange={handleSelectChange}
                    >
                        {usedSceneData.map((item, index) => {
                            return (
                                <NCOption key={`${item.value}${index}`} value={item.value}>
                                    {item.display}
                                </NCOption>
                            );
                        })}
                    </NCSelect>
                </span>
            </div>
        );
    };

    if ((!currentRefPk.current && !selectCard.isdatapowerenable) || usedSceneData.length === 0) {return null;}
    //使用场景有数据才显示
    return (
        <div className="mdcontent">
            {renderDataPowerEnable()}
            {renderUsedScene()}
        </div>
    );
}
export default connect(state => ({ selectCard: state.zoneSettingData.selectCard }))(DataPermissionArea);
